import { useTranslate } from "@tolgee/react";
import { MARKET_TRADES_GRID_CLASS } from "./constants/market-trades.constants.ts";
import { MarketTradesRow } from "./market-trades-row.tsx";

type MarketTrade = {
	tid: string | number;
	px: string | number | null | undefined;
	sz: string | number | null | undefined;
	time: number | null | undefined;
	side: string;
};

type MarketTradesTableProps = {
	trades: MarketTrade[];
	coin: string;
};

export function MarketTradesTable({ trades, coin }: MarketTradesTableProps) {
	const { t } = useTranslate();
	return (
		<>
			<div
				className={`${MARKET_TRADES_GRID_CLASS} border-b border-trade-border-subtle px-4 py-2 text-label2-medium uppercase text-trade-text-faint`}
			>
				<span>{t("form.price")} (USDC)</span>
				<span className="text-right">
					{t("form.amount")} ({coin})
				</span>
				<span className="text-right">{t("portfolio.time")}</span>
			</div>
			<div className="min-h-0 flex-1 overflow-y-auto px-2 py-2">
				{trades.map((trade) => (
					<MarketTradesRow key={trade.tid} trade={trade} />
				))}
			</div>
		</>
	);
}
